import { useMutation } from "@tanstack/react-query";

import { useAxios, useApiResponseParser } from "../";

export default function useReport() {
    const { axiosPrivate } = useAxios();
    const { parseSuccessResponseData, parseErrorResponseData } = useApiResponseParser();

    function useGeneratePreCannedReport() {
        return useMutation({
            mutationFn: async (params: any) => {
                const response = await axiosPrivate.get(`/v1/report/generate`, {
                    params,
                    responseType: "blob", // ⬅️ This is key for binary file downloads
                });

                // Try to extract filename from header
                const filename = response.headers["file-name"] || "download-file";

                // Create temporary download link
                const blob = new Blob([response.data]);
                const blobUrl = window.URL.createObjectURL(blob);
                const link = document.createElement("a");

                link.href = blobUrl;
                link.download = filename;
                document.body.appendChild(link);
                link.click();

                // Cleanup
                window.URL.revokeObjectURL(blobUrl);
                document.body.removeChild(link);

                return true; // or any other value to return
            },
        });
    }

    function useGenerateClaimsEstimate() {
        return useMutation({
            mutationFn: async (params: { ProjectId: string; TaxRate?: number }) => {
                const response = await axiosPrivate.get(`/v1/report/generate`, {
                    params: {
                        ReportType: "CLAIMS_ESTIMATE",
                        ...params,
                    },
                    responseType: "blob",
                });

                // Try to extract filename from header
                const filename = response.headers["file-name"] || "claims_estimate.pdf";

                // Create temporary download link
                const blob = new Blob([response.data], { type: "application/pdf" });
                const blobUrl = window.URL.createObjectURL(blob);
                const link = document.createElement("a");

                link.href = blobUrl;
                link.download = filename;
                document.body.appendChild(link);
                link.click();

                // Cleanup
                window.URL.revokeObjectURL(blobUrl);
                document.body.removeChild(link);

                return true;
            },
        });
    }

    return { useGeneratePreCannedReport, useGenerateClaimsEstimate };
}
